var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.004,
    viewBox: "0 0 20 20.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_540",
    "data-name": "Union 540",
    d: "M13722.889-18539.553a5.56,5.56,0,0,1,5.555-5.555,5.56,5.56,0,0,1,5.556,5.555,5.56,5.56,0,0,1-5.556,5.555A5.56,5.56,0,0,1,13722.889-18539.553Zm3.087.2a.664.664,0,0,0,0,.941l2,2a.663.663,0,0,0,.47.2.67.67,0,0,0,.476-.2l2-2a.664.664,0,0,0,0-.941.665.665,0,0,0-.47-.2.665.665,0,0,0-.471.2l-.866.861v-3.725a.666.666,0,0,0-.666-.666.667.667,0,0,0-.666.666v3.721l-.861-.857a.663.663,0,0,0-.47-.2A.667.667,0,0,0,13725.976-18539.357Zm-2.654,5.355h0Zm-6.323,0a3,3,0,0,1-3-2.994v-14a3.008,3.008,0,0,1,3-3h5.588a2,2,0,0,1,1.415.592l5.411,5.41a1.982,1.982,0,0,1,.555,1.043,7.709,7.709,0,0,0-1.523-.148,7.515,7.515,0,0,0-.912.051l-4.945-4.945H13717a1,1,0,0,0-1,1v14a1,1,0,0,0,1,1h4.782a7.577,7.577,0,0,0,1.541,2Zm10.779-4.5v0Zm-6.868-.5H13719a1,1,0,0,1-1-1,1,1,0,0,1,1-1h2.03a7.471,7.471,0,0,0-.14,1.443c0,.188.01.373.023.555Zm-1.909-4a1,1,0,0,1-1-1,1,1,0,0,1,1-1h4.21a7.519,7.519,0,0,0-1.49,2Z",
    transform: "translate(-13713.999 18554.002)",
    fill: "currentColor",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/ImportIcon.abc27e712eab1a5ed8525f6380fc71a5.svg";
export { ForwardRef as ReactComponent };